// @ts-strict-ignore
import React, { useState, useEffect, useRef } from 'react'
import { Image, ImageErrorEventData, NativeSyntheticEvent } from 'react-native'
import { useSelector } from 'APP/Hooks/redux'
import styled from 'styled-components/native'

import { getColourScheme } from 'APP/Helpers/AppearanceUtils'
import UrlBuilder from 'APP/Helpers/UrlBuilder'
import I18n from 'APP/I18n'

import Config from 'APP/Config'
import Typography from 'APP/Converse/Typography'
import { logger } from 'APP/Lib/Datadog'

const CobrandingContainer = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin}px;
  ${(props) => props.customStyling}
`

const CobrandingImage = styled(Image)`
  resize-mode: contain;
  width: 120;
  height: 60;
`

interface CobrandingProps {
  style?: object
}

const Cobranding: React.FC<CobrandingProps> = ({ style }) => {
  const cobrands = useSelector((state) => state.patient?.profile?.cobrands || [])
  const [imageFailedToLoad, setImageFailedToLoad] = useState<boolean>(false)
  const selectedCobrand = cobrands[0]

  const cobrandingImageURL =
    cobrands && cobrands.length === 1
      ? UrlBuilder.cobrandAssetUrl(selectedCobrand, getColourScheme(), I18n.baseLocale)
      : null

  // Seeded with the current URL so mounting is not treated as a change. The image
  // can fail before this effect first runs, and resetting on mount would discard
  // that failure and leave the component rendered with no image.
  const previousImageURL = useRef(cobrandingImageURL)
  useEffect(() => {
    if (previousImageURL.current === cobrandingImageURL) {
      return
    }
    previousImageURL.current = cobrandingImageURL
    setImageFailedToLoad(false)
  }, [cobrandingImageURL])

  const handleImageError = (event: NativeSyntheticEvent<ImageErrorEventData>) => {
    setImageFailedToLoad(true)
    const errorData = {
      error: event.nativeEvent?.error,
      cobrand: selectedCobrand,
      cobrandingImageURL,
    }
    logger.error(`Error loading cobranding image`, { ...errorData })
  }

  if (!Config.COBRANDING_ENABLED || !cobrandingImageURL || imageFailedToLoad) return null

  return (
    <CobrandingContainer testID="COBRANDING_ID" customStyling={style}>
      <Typography variant="bodyNormal">{I18n.t('Cobranding.broughtBy')}</Typography>
      <CobrandingImage source={{ uri: cobrandingImageURL }} onError={handleImageError} />
    </CobrandingContainer>
  )
}

export default Cobranding
